import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import type { Employee } from "../lib/types";

export default function Employees() {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (status) params.set("status", status);
    setLoading(true);
    const timeout = setTimeout(() => {
      api<{ employees: Employee[] }>(`/employees?${params.toString()}`)
        .then((res) => setEmployees(res.employees))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(timeout);
  }, [q, status]);

  return (
    <div>
      <div className="topbar">
        <div>
          <h1 className="page-title">Employees</h1>
          <div className="page-subtitle">Manage business card profiles</div>
        </div>
        <Link to="/employees/new" className="btn btn-gold">
          + Create New Business Card
        </Link>
      </div>

      <div className="card" style={{ marginBottom: 16, display: "flex", gap: 12, flexWrap: "wrap" }}>
        <input
          placeholder="Search by name, ID, phone, email, department…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          style={{ flex: 1, minWidth: 240, padding: "9px 12px", border: "1px solid var(--color-border)", borderRadius: 8 }}
        />
        <select value={status} onChange={(e) => setStatus(e.target.value)} style={{ padding: "9px 12px", border: "1px solid var(--color-border)", borderRadius: 8 }}>
          <option value="">All statuses</option>
          <option value="DRAFT">Draft</option>
          <option value="ACTIVE">Active</option>
          <option value="SUSPENDED">Suspended</option>
          <option value="ARCHIVED">Archived</option>
        </select>
      </div>

      <div className="card">
        {loading ? (
          <div className="empty-state">Loading…</div>
        ) : employees.length === 0 ? (
          <div className="empty-state">No employees match your search.</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Employee</th>
                <th>Job Title</th>
                <th>Department</th>
                <th>Status</th>
                <th>Wallets</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((e) => (
                <tr key={e.id}>
                  <td>
                    <Link to={`/employees/${e.id}`}>
                      <strong>{e.displayName}</strong>
                    </Link>
                    <div className="muted">{e.employeeId}</div>
                  </td>
                  <td>{e.jobTitle}</td>
                  <td>{e.department ?? "—"}</td>
                  <td>
                    <span className={`badge badge-${e.status.toLowerCase()}`}>{e.status}</span>
                  </td>
                  <td>
                    {(e.walletPasses ?? [])
                      .filter((p) => p.status === "GENERATED")
                      .map((p) => p.provider)
                      .join(", ") || "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
